import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";

/**
 * System-wide UX fix (2026-07-09): number inputs across the app default to 0 (opening stock,
 * reorder level, quantities, amounts, etc.), and typing without first clearing that "0" produced
 * results like "05" instead of "5". Rather than patch dozens of individual number inputs one by
 * one, this delegates a single `focusin` listener at the document root: whenever any
 * `input[type=number]` receives focus, its content is selected, so the very next keystroke
 * replaces the "0" (or whatever was there) instead of appending to it. This applies to every
 * number input in the app, present and future, without each feature needing its own onFocus prop.
 */
function useSelectNumberInputOnFocus() {
  useEffect(() => {
    function handleFocusIn(e: FocusEvent) {
      const target = e.target;
      if (target instanceof HTMLInputElement && target.type === "number") {
        target.select();
      }
    }
    document.addEventListener("focusin", handleFocusIn);
    return () => document.removeEventListener("focusin", handleFocusIn);
  }, []);
}

export default function App() {
  useSelectNumberInputOnFocus();
  return <RouterProvider router={router} />;
}